import React, { useState, useEffect } from "react";
import API_URL from "../apiConfig";
import "../styles/SalaryManagement.css";

export default function SalarySlipModal({ token, payment, onClose }) {
  const [slipData, setSlipData] = useState(null);

  useEffect(() => {
    if (payment) {
      fetch(`${API_URL}/api/salary_expense/slip/${payment.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => res.json())
      .then(setSlipData);
    }
  }, [payment, token]);

  if (!slipData) return null;

  return (
    <div className="modal-bg">
      <div className="modal">
        <h3>Salary Slip</h3>
        <div>
          <strong>Staff:</strong> {slipData.name} ({slipData.position})<br/>
          <strong>Email:</strong> {slipData.email}<br/>
          <strong>Month/Year:</strong> {slipData.month}/{slipData.year}<br/>
          <strong>Basic Pay:</strong> ₹{slipData.basic_pay}<br/>
          <strong>Allowances:</strong> ₹{slipData.allowances}<br/>
          <strong>Deductions:</strong> ₹{slipData.deductions}<br/>
          <strong>Net Pay:</strong> ₹{slipData.net_pay}<br/>
          <strong>Mode:</strong> {slipData.mode}<br/>
          <strong>Remarks:</strong> {slipData.remarks}<br/>
          <strong>Voucher No:</strong> {slipData.voucher_no}
        </div>
        <div style={{marginTop:22, textAlign:"right"}}>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}